import type { Country } from '../country';
import { genericPhoneNumber } from '@tectonics/commons/customer-form/generic-phone-number';
import { validateTurkeyPhoneNumber } from '@tectonics/prs/turkey/validation/turkey-phone-number';

export const TURKEY_PHONE_MASK = [
  '+', '9', '0', ' ',
  /[5]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/,
];

const TURKEY: Country = {
  code: 'tr',
  customerForm: {
    phoneNumber: {
      ...genericPhoneNumber,
      mask: TURKEY_PHONE_MASK,
      validationFunction: validateTurkeyPhoneNumber,
      inputFieldName: 'turkeyPhoneNumber',
      tooltip: {
        label: '!',
        textKey: 'volcanes.customerForm.phoneNumber.tooltip.turkey',
      },
    },
  },
};

export default TURKEY;
